import './object-define-property.js';
import hasOwnProperty_1 from './has-own-property.js';
import wellKnownSymbol$1 from './well-known-symbol.js';
import { __exports as objectDefineProperty } from '../../../../../../_virtual/object-define-property.js';

var defineProperty = objectDefineProperty.f;
var hasOwn = hasOwnProperty_1;
var wellKnownSymbol = wellKnownSymbol$1;
var TO_STRING_TAG = wellKnownSymbol('toStringTag');

var setToStringTag = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;

  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, {
      configurable: true,
      value: TAG
    });
  }
};

export { setToStringTag as default };
